import { useState } from 'react';

function useRailsCsrfToken() {
  const [token] = useState(() => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta.getAttribute('content');
  });

  return token || '';
}

export default useRailsCsrfToken;
